import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen bg-white" }
const _hoisted_2 = { class: "max-w-sm mx-auto md:mt-8 p-4 md:border md:border-gray-300 rounded md:shadow-md" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block font-bold flex justify-start"
}, "Email *", -1)
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block font-bold flex justify-start"
}, "Password *", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full px-3 py-2 bg-black text-white border border-black rounded hover:bg-white hover:text-black"
}, " Login ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-6 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "w-40 h-px my-3 bg-gray-100 border-0 rounded bg-gray-300" }),
  /*#__PURE__*/_createElementVNode("p", { class: "mx-2" }, "ou"),
  /*#__PURE__*/_createElementVNode("hr", { class: "w-40 h-px my-3 bg-gray-100 border-0 rounded bg-gray-300" })
], -1)
const _hoisted_10 = { class: "mt-3 flex justify-center" }
const _hoisted_11 = { class: "w-full py-2 border border-black rounded hover:bg-black hover:text-white" }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = ["textContent"]

import { ref} from 'vue';
  import { useRouter } from 'vue-router'
  import { useCurrentCompanyStore } from '../stores/CurrentCompanyStore'
  import { useUserStore } from '../stores/UserStore'
  import { storeToRefs } from 'pinia'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

  const {login } = useUserStore()

  
  const router = useRouter()
  // const {currentCompanyId } = storeToRefs(useCurrentCompanyStore())
  // const {userEmail, userFirstName, userLastName, userPhoneNumber,userCompanyId,userId,userRole } = storeToRefs(useUserStore())
  
  let email= ref("")
  let password= ref("")
  let message= ref("")

  async function signIn(){
    const _login = await login(email.value,password.value);
    if (_login){
      router.push('/');
    }
    else{
      message.value = "wrong email/password";
    }
  }

  // async function login() {
  //   try {
  //       const response = await fetch(`${process.env.VUE_APP_API_BASE}/api/Auth/login`, {
  //         method: "POST",
  //         headers: {
  //             'Content-Type': 'application/json',
  //         },
  //         credentials: 'include',
  //         body: JSON.stringify({  
  //             Email: email.value,
  //             Password: password.value })  
  //       });

  //       if (response.ok) {
  //           console.log("Request succeeded");
  //           const responseJSON = await response.json();
  //           userEmail.value=responseJSON.email;
  //           userFirstName.value=responseJSON.firstName;
  //           userLastName.value=responseJSON.lastName;
  //           userPhoneNumber.value=responseJSON.phoneNumber;
  //           userCompanyId.value=responseJSON.companyID;
  //           userRole.value=responseJSON.role;
  //           userId.value=responseJSON.userId;

  //           sessionStorage.setItem('userEmail',responseJSON.email);
  //           sessionStorage.setItem('userId',responseJSON.userId );
  //           sessionStorage.setItem("companyID", responseJSON.companyID);
  //           sessionStorage.setItem("firstName", responseJSON.firstName);
  //           sessionStorage.setItem("lastName", responseJSON.lastName);
  //           sessionStorage.setItem("role", responseJSON.role);
  //           sessionStorage.setItem("phoneNumber", responseJSON.phoneNumber);

  //           if (Number(currentCompanyId.value) !== 0) {
  //               router.push(`/company/${currentCompanyId.value}`);
  //           } else {
  //               router.push(`/`);
  //           }
  //       } else {
  //           const errorMessage = await response.text();
  //           message.value = "wrong email/password"
  //           console.error(`Request failed with status ${response.status}: ${errorMessage}`);
  //       }
  //   } catch (error) {
  //       console.error(error);
  //   }
  // }

  
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(signIn, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            id: "email",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
            required: "",
            class: "w-full px-3 py-2 border rounded"
          }, null, 512), [
            [_vModelText, _unref(email)]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            id: "password",
            placeholder: "Password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
            required: "",
            class: "w-full px-3 py-2 border rounded"
          }, null, 512), [
            [_vModelText, _unref(password)]
          ])
        ]),
        _hoisted_8
      ], 40, _hoisted_3),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", _hoisted_11, [
          _createVNode(_component_router_link, { to: "/register" }, {
            default: _withCtx(() => [
              _createTextVNode("Créer mon compte")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", {
            id: "message",
            textContent: _toDisplayString(_unref(message)),
            class: "w-full text-red-500 text-center"
          }, null, 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}
}

})